export enum AskRequisitionStatusAudienceTypeEnum {
    CoworkerWithQuestion = 1,
    Customer = 2,
    CoworkerWithOutQuestion = 3,
}